import store from '@/store'

function install() {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://duffarn.no/chat-widget.js`

    script.addEventListener('load', () => resolve())
    script.addEventListener('error', reject)

    document.head.appendChild(script)
  })
}

export default function () {
  if (!store.getters.isSuperadmin) return

  return install()
}
